import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { useNavigate } from 'react-router-dom';
import { compose } from 'redux';
import { FiltersContainer, SelectsContainer, Filter } from './style';
import routes from '../../../routes';
import { NoResult, CustomSelect, CTA } from '../../../ui/atoms';
import { SEARCH_DOCUMENTS_LIST_GET } from '../../redux/actions/search';
import Pagination from '../../../ui/atoms/Pagination';
import { flattenCategories } from '../../../utils/categories';
import { DocumentsGrid, Legend, SelectWrapper } from '../Documents/style';
import CardDocuments from '../../../ui/atoms/Cards/CardDocuments';
import SortBy from '../../../ui/atoms/SortBy';
import { formatFilterOpt, getFilterLabel } from '../../../utils/labels';
import { withMediaQueries } from '../../hoc/withMediaQueries';
import { StickyFiltersWrapper } from '../../../ui/atoms/CTA/style';
import ModalFilters, {
  ModalFiltersId,
} from '../../../ui/atoms/Modals/ModalFilters';
import { MODAL_OPEN } from '../../redux/actions';

const DocumentsResults = ({
  mediaIsPhone,
  active,
  search_word,
  categories,
  getDocuments,
  list,
  filters,
  pager,
  modalOpen,
}) => {
  const navigate = useNavigate();
  const [selectedFilters, setSelectedFilters] = useState({});

  const handleGetDocuments = (page) => {
    getDocuments({
      title: search_word,
      filters: { ...selectedFilters, categoryType: 'single_categories', page },
    });
  };

  useEffect(() => {
    if (Object.keys(selectedFilters)?.length > 0) {
      handleGetDocuments();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFilters]);

  const handleOnChange = ({ key, value }) => {
    const newFilters = { ...selectedFilters };
    newFilters[key] = value?.value;
    setSelectedFilters(newFilters);
  };

  const loadMore = (page) => handleGetDocuments(page);
  const setItemsPerPage = (v) =>
    handleOnChange({ key: 'items_per_page', value: v });

  return (
    <>
      {mediaIsPhone ? (
        <StickyFiltersWrapper>
          <CTA
            btnText="Filtri"
            type="secondary"
            fullsize
            onClick={() =>
              modalOpen(ModalFiltersId, {
                filters: {
                  categories: flattenCategories(categories),
                  ...filters,
                },
                activeFilters: selectedFilters,
              })
            }
          />
        </StickyFiltersWrapper>
      ) : (
        <FiltersContainer>
          <SelectsContainer>
            <Filter>
              <CustomSelect
                placeholder="Area tematica"
                options={flattenCategories(categories, 0, true)}
                onChange={(value) => {
                  handleOnChange({ key: 'single_categories', value });
                }}
              />
            </Filter>
            {(Object.keys(filters) || []).map((key, i) => (
              <SelectWrapper key={`filter-${i}`}>
                <CustomSelect
                  placeholder={getFilterLabel(key)}
                  options={filters[key].map((opt) => formatFilterOpt(opt))}
                  onChange={(value) => handleOnChange({ key, value })}
                  isClearable
                />
              </SelectWrapper>
            ))}
            <SortBy
              onChange={(v) => {
                setSelectedFilters({ ...selectedFilters, sort_by: v?.value });
              }}
            />
          </SelectsContainer>
        </FiltersContainer>
      )}
      {/* ALL DOCUMENTS */}
      {list?.length > 0 ? (
        <>
          <Legend>
            <p>FORMATO</p>
            <p>TITOLO </p>
            <p>TIPOLOGIA </p>
            <p>DATA</p>
            <p>DIMENSIONI</p>
          </Legend>
          <DocumentsGrid>
            {(list || []).map((item) => (
              <CardDocuments
                key={`document-${item?.id}`}
                item={item}
                onClick={() =>
                  navigate(`${routes.documentDetails.path}/${item.id}`)
                }
                handleGetDocuments={handleGetDocuments}
              />
            ))}
          </DocumentsGrid>
          <Pagination
            pager={pager}
            callBack={loadMore}
            setItemsPerPage={setItemsPerPage}
          />
        </>
      ) : (
        <NoResult />
      )}
      {mediaIsPhone && active && (
        <ModalFilters
          onClick={(newFilters) => setSelectedFilters(newFilters)}
        />
      )}
    </>
  );
};

DocumentsResults.propTypes = {
  mediaIsPhone: PropTypes.bool,
  active: PropTypes.bool,
  // HOC (connect, state)
  search_word: PropTypes.string,
  list: PropTypes.array.isRequired,
  filters: PropTypes.object,
  pager: PropTypes.object,
  categories: PropTypes.array,
  //HOC (connect, dispatch)
  getDocuments: PropTypes.func.isRequired,
  modalOpen: PropTypes.func.isRequired,
};

export default compose(
  connect(
    (state) => {
      const {
        search_word,
        documents: { list, pager, filters },
      } = state.search;
      const { categories } = state.documents;
      return {
        search_word,
        list,
        pager,
        filters,
        categories,
      };
    },
    (dispatch) => ({
      getDocuments: ({ filters, title }) =>
        dispatch({ type: SEARCH_DOCUMENTS_LIST_GET._REQUEST, filters, title }),
      modalOpen: (id, payload) => dispatch({ type: MODAL_OPEN, id, payload }),
    })
  ),
  withMediaQueries
)(DocumentsResults);
